import { render, staticRenderFns } from "./addusers.vue?vue&type=template&id=0d817d84"
import script from "./addusers.vue?vue&type=script&lang=js"
export * from "./addusers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports